import styled from 'styled-components';

export const StyledModalWrapper = styled.div<{ background?: string }>`
  .backdrop {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    opacity: 0;
    width: 100%;
    height: 100%;
    background-color: #3d59774d;
    backdrop-filter: blur(5px);
    transition: opacity 0.3s;
  }

  .backdrop-active {
    opacity: 1;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #3d59774d;
    backdrop-filter: blur(5px);
    transition: opacity 0.3s;
  }

  .modal-content {
    max-width: 380px;
    direction: rtl;
    position: absolute;
    top: 50%;
    left: 50%;
    border-radius: ${({ theme }): string => theme.radii.xxl};
    width: 80%;
    transform: translate(-50%, -50%);
    z-index: 12;
    background-color: ${({ theme, background }): string =>
      background || theme.colors.secondaryBackground};
    padding: 16px;
    font-size: ${({ theme }): string => theme.fontSizes[4]};
    overflow: hidden;
  }
`;
